import { ConfirmAccountRequestComponent } from './account-request/confirm-account-request/confirm-account-request.component';
import { CommonComponentsModule } from './../common-components/common-components.module';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { AuthService } from './service/auth.service';
import { authReducer } from './state/reducers';
import { AuthGuard } from '../../guards/auth.guard';
import { EffectsModule } from '@ngrx/effects';
import { AuthEffects } from './state/auth.effects';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ForgotUsernameComponent } from './forgot-username/forgot-username.component';
//import { RecaptchaModule, RecaptchaFormsModule, RecaptchaSettings, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { RecaptchaComponent } from './recaptcha/recaptcha.component';
import { environment } from 'src/environments/environment';
import { AccountRequestComponent } from './account-request/account-request.component';
import { MaterialModule } from 'src/app/material/material.module';
import { RulesOfBehaviorComponent } from './account-request/rules-of-behavior/rules-of-behavior.component';
import { ResendConfirmationCodeComponent } from './account-request/resend-confirmation-code/resend-confirmation-code.component';
import { ForgotPasswordChangeComponent } from './forgot-password-change/forgot-password-change.component';
import { NewAccountCreationComponent } from './new-account-creation/new-account-creation.component';
import { UserProfileModule } from './../user-profile/user-profile.module';
import { RobRequiredComponent } from './rob-required/rob-required.component';
import { PasswordChangeRequiredComponent } from './password-change-required/password-change-required.component';
import { OtherSessionsActiveComponent } from './other-sessions-active/other-sessions-active.component';
import { AccountRequestUpdateComponent } from './account-request-update/account-request-update.component';
import { IdleTimeoutComponent } from './idle-timeout/idle-timeout.component';
import { IdleTimeoutModalComponent } from './idle-timeout/idle-timeout-modal/idle-timeout-modal.component';
import { SessionTrackerComponent } from './session-tracker/session-tracker.component';

// const globalSettings: RecaptchaSettings = {
//     siteKey: environment.recaptchaSiteKey
// };

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MaterialModule,
        RouterModule.forChild([{ path: '', component: LoginComponent }]),
        StoreModule.forFeature('auth', authReducer),
        EffectsModule.forFeature([AuthEffects]),
        // RecaptchaModule,
        // RecaptchaFormsModule,
        FormsModule,
        CommonComponentsModule,
        UserProfileModule
    ],
    declarations: [
        LoginComponent,
        ForgotPasswordComponent,
        ForgotUsernameComponent,
        RecaptchaComponent,
        AccountRequestComponent,
        AccountRequestUpdateComponent,
        RulesOfBehaviorComponent,
        ResendConfirmationCodeComponent,
        ConfirmAccountRequestComponent,
        ForgotPasswordChangeComponent,
        NewAccountCreationComponent,
        RobRequiredComponent,
        PasswordChangeRequiredComponent,
        OtherSessionsActiveComponent,
        IdleTimeoutComponent,
        IdleTimeoutModalComponent,
        SessionTrackerComponent
    ],
    exports: [LoginComponent, IdleTimeoutComponent, SessionTrackerComponent]
})
export class AuthModule {
    static forRoot(): ModuleWithProviders<AuthModule> {
        return {
            ngModule: AuthModule,
            providers: [
                AuthService,
                AuthGuard
                // {
                //     provide: RECAPTCHA_SETTINGS,
                //     useValue: globalSettings
                // }
            ]
        };
    }
}
